<template>
    <a-row :gutter="24">
      <a-col :md="24">
        <a-card :style="cardStyle1" :bordered="false">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <!-- 搜索区域 -->
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!-- <a-select placeholder="请选择公司名称" optionFilterProp="children" v-model="queryParam.specification">
                      <a-select-option v-for="(item,index) in specList" :key="index" :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select> -->
                    <a-input placeholder="请选择公司名称" v-model="queryParam.company"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">

                    <a-select style="width:90%;" showSearch optionFilterProp="children" v-model="queryParam.codeSystem" :allowClear="true">
                      <a-select-option v-for="(item,index) in matype" :key="index" :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="8" :lg="6"  :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>

                  </a-col>
                </span>

              </a-row>

            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <!-- <a-button type="primary" @click="searchQuery">查询</a-button> -->
          <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button>
        </div>
          <!-- table区域-begin -->
          <div>
            <a-table ref="table" size="middle" bordered :rowKey="(record,index)=>{return index}"
              :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
              :pagination="ipagination" :scroll="{ y: 500, x: 1400 }" :loading="loading"
              :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'50px'}"
              @change="handleTableChange" style="word-break: break-all;">
              <span slot="action" slot-scope="text, record">
                <a-popconfirm title="是否通过审批?" ok-text="通过" cancel-text="不通过" @confirm="() => handleAudit(record,1)" @cancel="() => handleAuditCancel(record,2)">
                  <a v-if="record.state === 1" disabled type="primary">审批</a>
                  <a v-else type="primary">审批</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
                  <a type="primary">删除</a>
                </a-popconfirm>
              </span>
              <template slot="createTime" slot-scope="createTime">
                <span>{{changetime(createTime)}}</span>
              </template>
              <template slot="state" slot-scope="state">
                <a-tag v-if="state === 0" color="blue">待审核</a-tag>
                <a-tag v-else-if="state === 1" color="blue">审核中</a-tag>
                <a-tag v-else-if="state === 2" color="green">审核通过</a-tag>
                <a-tag v-else-if="state === 3" color="red">未通过</a-tag>
              </template>

            </a-table>
          </div>
          <!-- table区域-end -->
          <!-- 表单区域 -->

          <addModel ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></addModel>
        </a-card>
      </a-col>
    </a-row>
  </template>
  <!-- create ji sheng hua-->
  <script>
 //ledgerAdd
  import addModel from '../modules/addModel'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { ledgerDelete,ledgerEdit } from '@/api/api'
  import JDate from '@/components/jeecg/JDate'


  export default {
    name: 'RetailOutList',
    mixins: [JeecgListMixin],
    components: {

      addModel,
      JDate,
    },
    data() {
      return {
        ipagination: {
          pageSizeOptions: ['10', '20', '30', '100', '200'],
        },
        // 查询条件
        queryParam: {
          page: 1,
          limit: 20,
          // keywords: '',
          // specification: '',
          // codeSystem:''
        },
        prefixNo: 'LSCK',
        labelCol: {
          span: 5,
        },
        wrapperCol: {
          span: 18,
          offset: 1,
        },
        specList: [
          {
            // 包装规格
            label: 'A公司',
            value: '0',
          },
          {
            label: 'B公司',
            value: '1',
          }
        ],
        matype: [
          {
            label: '待审核',
            value: '1',
          },
          {
            label: '审核通过',
            value: '2',
          }
        ], // 包装规格
        // 默认列
        columns: [
          { title: '单据编号', dataIndex: 'code', width: 150, ellipsis: true, render: (text) => text || "--" },
          { title: '制单时间', dataIndex: 'preparedTime',width: 120, render: (text) => text || "--"},
          { title: '编码(单位根)', dataIndex: 'ma', width: 180, render: (text) => text || "--" },
          { title: '公司名称', dataIndex: 'company', width: 200 ,ellipsis: true, render: (text) => text || "--" },
          { title: '法定代表人', dataIndex: 'legal',width: 120, render: (text) => text || "--"},
          { title: '统一社会信用代码', dataIndex: 'credit', width: 280, render: (text) => text || "--" },
          { title: '注册资金', dataIndex: 'capital',width: 120, render: (text) => text || "--"},
          { title: '申请原因', dataIndex: 'reason',width: 300, render: (text) => text || "--"},
          { title: '状态', dataIndex: 'state',width: 100, align: "center",scopedSlots: { customRender: 'state' }, fixed: 'right',  },

          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 140,
            fixed: 'right',
            scopedSlots: { customRender: 'action' },
          },
        ],
        url: {
          list: '/firstCamp/fcFirstCampLedger/list',

        },
      }
    },
    computed: {},
    created() {

    },
    methods: {

      changetime(createTime) {
        return createTime.replace('T', ' ')
      },
      async handleAudit(record,e) {
        console.log(record,'审核record============')
        let params = {
          uuid : record.uuid,
          state: e
        }
        const res = await ledgerEdit(params)
        this.loadData()
      },
      //handleAuditCancel
      async handleAuditCancel(record,e) {
        console.log(record,'审核record============')
        let params = {
          uuid : record.uuid,
          state: e
        }
        const res = await ledgerEdit(params)
        this.loadData()
      },

      //删除handleDelete
      async handleDelete(record) {
        let params = {
          id : record.uuid
        }
        const res = await ledgerDelete(params)
        if (res.code == 200 && res.success == true) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.error(res.message)
        }

      },
    },
  }
  </script>
  <style scoped>
  @import '~@assets/less/common.less';
  /deep/.ant-table-row-cell-break-word:empty:after {
    content: '--';
  }
  </style>